module.exports = __webpack_public_path__ + "static/media/block-3-item-2.70ed3352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-3-item-2.jpg
// module id = 1258
// module chunks = 270